module.exports = __webpack_public_path__ + "img/playera_2.514a7a68.png";